// extracted by mini-css-extract-plugin
module.exports = {"costType":"TripCartAsidePriceHeader_costType__6qjL2","root":"TripCartAsidePriceHeader_root__di9Yu","left":"TripCartAsidePriceHeader_left__oLm_S"};